const HelloPeterWidget = () => {
  return (
    <>
      <div style={{ paddingTop: '50px' }}>
        <iframe
          id="hellopeter-widget"
          src="/hellopeter-widget.html"
          width="940"
          style={{
              display: 'block',
              border: 'none',
              margin: 0,
              padding: 0,
              width: '100%',
              minHeight: '340px',
              overflow: 'hidden'
          }}
          title="HelloPeter Reviews"
      />
      </div>
    </>
  );
};

export default HelloPeterWidget;
